// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.performance-dashboard {
  width: 100%;
  min-height: 100%;
  max-height: none;
  overflow: visible;
}

.performance-candidate-filter {
  flex: 1 1;
  min-width: 210px;
}

.performance-candidate-filter input {
  width: 100%;
}

.performance-filters select {
  border: 0;
  outline: 0;
  background: transparent;
  color: #344054;
}

.performance-explorer {
  margin-bottom: 12px;
  padding: 17px;
  border: 1px solid #ded7ff;
  border-radius: 15px;
  background: linear-gradient(135deg, #ffffff, #faf9ff);
  box-shadow: 0 4px 16px rgba(91, 53, 245, 0.06);
}

.performance-explorer-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
}

.performance-explorer-heading > div:first-child > span {
  color: #6846f5;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.14em;
}

.performance-explorer-heading h3 {
  margin: 3px 0;
  font-size: 16px;
  text-transform: capitalize;
}

.performance-explorer-heading p {
  margin: 0;
  color: #98a2b3;
  font-size: 9px;
}

.performance-explorer-heading > div:last-child {
  display: flex;
  gap: 8px;
}

.performance-explorer-heading label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #667085;
  font-size: 9px;
  font-weight: 800;
}

.performance-explorer-heading select {
  min-width: 130px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid #ddd6fe;
  border-radius: 9px;
  background: #fff;
  color: #344054;
  outline: 0;
}

.performance-explorer-grid {
  display: grid;
  grid-template-columns: minmax(330px, 0.75fr) minmax(520px, 1.25fr);
  gap: 12px;
  margin-top: 12px;
}

.performance-explorer-grid > article {
  min-width: 0;
  border: 1px solid #eceaf7;
  border-radius: 12px;
  background: #fff;
}

.explorer-pie > div:last-child {
  padding-bottom: 0;
}

.explorer-legend {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;
  max-height: 150px;
  padding: 0 10px 10px;
  overflow: auto;
}

.explorer-legend button {
  display: grid;
  grid-template-columns: 8px 1fr auto;
  align-items: center;
  gap: 6px;
  padding: 6px;
  border: 0;
  border-radius: 7px;
  background: #fafaff;
  color: #344054;
  text-align: left;
  cursor: pointer;
}

.explorer-legend i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.explorer-legend span {
  overflow: hidden;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.explorer-legend strong {
  font-size: 10px;
}

@media (max-width: 900px) {
  .performance-dashboard {
    width: 100%;
  }

  .performance-explorer-heading {
    align-items: stretch;
    flex-direction: column;
  }

  .performance-explorer-grid {
    grid-template-columns: 1fr;
  }
}

/* Full-width responsive Bench Sales Performance layout */
.performance-dashboard {
  width: 100% !important;
  max-width: none !important;
  min-width: 0;
  min-height: 100%;
  max-height: none !important;
  margin: 0;
  box-sizing: border-box;
  overflow: visible !important;
}

.performance-dashboard *,
.performance-dashboard *::before,
.performance-dashboard *::after {
  box-sizing: border-box;
}

.performance-dashboard .performance-chart-grid {
  width: 100%;
  grid-template-columns: minmax(280px, .72fr) minmax(0, 1.28fr);
}

.performance-dashboard .performance-chart-grid.lower {
  grid-template-columns: minmax(0, 1.3fr) minmax(280px, .7fr);
}

.performance-dashboard .performance-explorer-grid {
  grid-template-columns: minmax(280px, .75fr) minmax(0, 1.25fr);
}

.performance-dashboard .performance-chart-grid > *,
.performance-dashboard .performance-explorer-grid > * {
  min-width: 0;
}

@media (max-width: 1180px) {
  .performance-dashboard .performance-chart-grid,
  .performance-dashboard .performance-chart-grid.lower,
  .performance-dashboard .performance-explorer-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 900px) {
  .performance-dashboard {
    padding: 14px;
  }

  .performance-dashboard .performance-filters {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .performance-dashboard .performance-filters .performance-search,
  .performance-dashboard .performance-candidate-filter {
    min-width: 0;
  }
}

@media (max-width: 560px) {
  .performance-dashboard {
    padding: 10px;
  }

  .performance-dashboard .performance-header {
    gap: 10px;
  }

  .performance-dashboard .performance-header h2 {
    font-size: 20px;
  }

  .performance-dashboard .performance-filters {
    grid-template-columns: 1fr;
  }

  .performance-dashboard .performance-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .performance-dashboard .performance-explorer {
    padding: 12px;
  }

  .performance-dashboard .performance-explorer-heading > div:last-child {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .performance-dashboard .performance-explorer-heading select {
    width: 100%;
    min-width: 0;
  }
}
.performance-pagination{display:flex;align-items:center;justify-content:flex-end;gap:12px;padding:14px 0}
.performance-pagination button{border:1px solid #ddd6fe;border-radius:8px;padding:8px 13px;background:#fff;color:#4f46e5;font-weight:700;cursor:pointer}
.performance-pagination button:disabled{opacity:.45;cursor:not-allowed}
.performance-page-size{display:flex;align-items:center;gap:7px;font-size:12px;font-weight:700}
.performance-page-size select{border:1px solid #d0d5dd;border-radius:7px;padding:6px}
.performance-record-link{border:0;padding:0;background:transparent;color:#4f46e5;font:inherit;font-weight:700;cursor:pointer}
.performance-record-link:hover{text-decoration:underline}
.performance-summary article[role="button"]{cursor:pointer;transition:transform .2s ease,box-shadow .2s ease,border-color .2s ease}
.performance-summary article[role="button"]:hover,.performance-summary article[role="button"]:focus-visible{transform:translateY(-3px);box-shadow:0 8px 20px rgba(52,64,84,.12);outline:none}
.performance-summary article[role="button"].active{border-color:#5b35f5;box-shadow:0 0 0 2px rgba(91,53,245,.12)}
.performance-summary article small{display:block;margin-top:5px;color:#667085;font-size:9px;font-weight:700}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/RecruiterPerformancePage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,yDAAyD;AACzD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,SAAS;EACT,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,6DAA6D;AAC/D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gDAAgD;EAClD;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA,wBAAwB,YAAY,CAAC,kBAAkB,CAAC,wBAAwB,CAAC,QAAQ,CAAC,cAAc;AACxG,+BAA+B,wBAAwB,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,eAAe,CAAC,aAAa,CAAC,eAAe,CAAC,cAAc;AACvJ,wCAAwC,WAAW,CAAC,kBAAkB;AACtE,uBAAuB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,cAAc,CAAC,eAAe;AAC7F,8BAA8B,wBAAwB,CAAC,iBAAiB,CAAC,WAAW;AACpF,yBAAyB,QAAQ,CAAC,SAAS,CAAC,sBAAsB,CAAC,aAAa,CAAC,YAAY,CAAC,eAAe,CAAC,cAAc;AAC5H,+BAA+B,yBAAyB;AACxD,4CAA4C,cAAc,CAAC,uEAAuE;AAClI,4GAA4G,0BAA0B,CAAC,wCAAwC,CAAC,YAAY;AAC5L,mDAAmD,oBAAoB,CAAC,wCAAwC;AAChH,mCAAmC,aAAa,CAAC,cAAc,CAAC,aAAa,CAAC,aAAa,CAAC,eAAe","sourcesContent":[".performance-dashboard {\n  width: 100%;\n  min-height: 100%;\n  max-height: none;\n  overflow: visible;\n}\n\n.performance-candidate-filter {\n  flex: 1;\n  min-width: 210px;\n}\n\n.performance-candidate-filter input {\n  width: 100%;\n}\n\n.performance-filters select {\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: #344054;\n}\n\n.performance-explorer {\n  margin-bottom: 12px;\n  padding: 17px;\n  border: 1px solid #ded7ff;\n  border-radius: 15px;\n  background: linear-gradient(135deg, #ffffff, #faf9ff);\n  box-shadow: 0 4px 16px rgba(91, 53, 245, 0.06);\n}\n\n.performance-explorer-heading {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 18px;\n}\n\n.performance-explorer-heading > div:first-child > span {\n  color: #6846f5;\n  font-size: 9px;\n  font-weight: 900;\n  letter-spacing: 0.14em;\n}\n\n.performance-explorer-heading h3 {\n  margin: 3px 0;\n  font-size: 16px;\n  text-transform: capitalize;\n}\n\n.performance-explorer-heading p {\n  margin: 0;\n  color: #98a2b3;\n  font-size: 9px;\n}\n\n.performance-explorer-heading > div:last-child {\n  display: flex;\n  gap: 8px;\n}\n\n.performance-explorer-heading label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  color: #667085;\n  font-size: 9px;\n  font-weight: 800;\n}\n\n.performance-explorer-heading select {\n  min-width: 130px;\n  height: 36px;\n  padding: 0 10px;\n  border: 1px solid #ddd6fe;\n  border-radius: 9px;\n  background: #fff;\n  color: #344054;\n  outline: 0;\n}\n\n.performance-explorer-grid {\n  display: grid;\n  grid-template-columns: minmax(330px, 0.75fr) minmax(520px, 1.25fr);\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.performance-explorer-grid > article {\n  min-width: 0;\n  border: 1px solid #eceaf7;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.explorer-pie > div:last-child {\n  padding-bottom: 0;\n}\n\n.explorer-legend {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 4px;\n  max-height: 150px;\n  padding: 0 10px 10px;\n  overflow: auto;\n}\n\n.explorer-legend button {\n  display: grid;\n  grid-template-columns: 8px 1fr auto;\n  align-items: center;\n  gap: 6px;\n  padding: 6px;\n  border: 0;\n  border-radius: 7px;\n  background: #fafaff;\n  color: #344054;\n  text-align: left;\n  cursor: pointer;\n}\n\n.explorer-legend i {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.explorer-legend span {\n  overflow: hidden;\n  font-size: 9px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.explorer-legend strong {\n  font-size: 10px;\n}\n\n@media (max-width: 900px) {\n  .performance-dashboard {\n    width: 100%;\n  }\n\n  .performance-explorer-heading {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .performance-explorer-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Full-width responsive Bench Sales Performance layout */\n.performance-dashboard {\n  width: 100% !important;\n  max-width: none !important;\n  min-width: 0;\n  min-height: 100%;\n  max-height: none !important;\n  margin: 0;\n  box-sizing: border-box;\n  overflow: visible !important;\n}\n\n.performance-dashboard *,\n.performance-dashboard *::before,\n.performance-dashboard *::after {\n  box-sizing: border-box;\n}\n\n.performance-dashboard .performance-chart-grid {\n  width: 100%;\n  grid-template-columns: minmax(280px, .72fr) minmax(0, 1.28fr);\n}\n\n.performance-dashboard .performance-chart-grid.lower {\n  grid-template-columns: minmax(0, 1.3fr) minmax(280px, .7fr);\n}\n\n.performance-dashboard .performance-explorer-grid {\n  grid-template-columns: minmax(280px, .75fr) minmax(0, 1.25fr);\n}\n\n.performance-dashboard .performance-chart-grid > *,\n.performance-dashboard .performance-explorer-grid > * {\n  min-width: 0;\n}\n\n@media (max-width: 1180px) {\n  .performance-dashboard .performance-chart-grid,\n  .performance-dashboard .performance-chart-grid.lower,\n  .performance-dashboard .performance-explorer-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 900px) {\n  .performance-dashboard {\n    padding: 14px;\n  }\n\n  .performance-dashboard .performance-filters {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .performance-dashboard .performance-filters .performance-search,\n  .performance-dashboard .performance-candidate-filter {\n    min-width: 0;\n  }\n}\n\n@media (max-width: 560px) {\n  .performance-dashboard {\n    padding: 10px;\n  }\n\n  .performance-dashboard .performance-header {\n    gap: 10px;\n  }\n\n  .performance-dashboard .performance-header h2 {\n    font-size: 20px;\n  }\n\n  .performance-dashboard .performance-filters {\n    grid-template-columns: 1fr;\n  }\n\n  .performance-dashboard .performance-summary {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .performance-dashboard .performance-explorer {\n    padding: 12px;\n  }\n\n  .performance-dashboard .performance-explorer-heading > div:last-child {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    width: 100%;\n  }\n\n  .performance-dashboard .performance-explorer-heading select {\n    width: 100%;\n    min-width: 0;\n  }\n}\n.performance-pagination{display:flex;align-items:center;justify-content:flex-end;gap:12px;padding:14px 0}\n.performance-pagination button{border:1px solid #ddd6fe;border-radius:8px;padding:8px 13px;background:#fff;color:#4f46e5;font-weight:700;cursor:pointer}\n.performance-pagination button:disabled{opacity:.45;cursor:not-allowed}\n.performance-page-size{display:flex;align-items:center;gap:7px;font-size:12px;font-weight:700}\n.performance-page-size select{border:1px solid #d0d5dd;border-radius:7px;padding:6px}\n.performance-record-link{border:0;padding:0;background:transparent;color:#4f46e5;font:inherit;font-weight:700;cursor:pointer}\n.performance-record-link:hover{text-decoration:underline}\n.performance-summary article[role=\"button\"]{cursor:pointer;transition:transform .2s ease,box-shadow .2s ease,border-color .2s ease}\n.performance-summary article[role=\"button\"]:hover,.performance-summary article[role=\"button\"]:focus-visible{transform:translateY(-3px);box-shadow:0 8px 20px rgba(52,64,84,.12);outline:none}\n.performance-summary article[role=\"button\"].active{border-color:#5b35f5;box-shadow:0 0 0 2px rgba(91,53,245,.12)}\n.performance-summary article small{display:block;margin-top:5px;color:#667085;font-size:9px;font-weight:700}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
